
// import { Link } from "react-router-dom";
// import React, { useState } from "react";

// const ExploreServices = () => {
//   const [type, setType] = useState("");

//   const services = [
//     {
//       image: "/image/plots.jpg",
//       title: "Modern Residences",
//       description: "Beautifully curated residential properties perfect for individuals and families from apartments to villas",
//       link: "/property",
//       propertyType: "Residential",
//       payloadKey: "building_type",
//     },
//     {
//       image: "/image/leasing.jpg",
//       title: "Smart Spaces for Business",
//       description: "Top commercial spaces for offices, retail, and startups.",
//       link: "/property",
//       propertyType: "Commercial",
//       payloadKey: "building_type",
//     },
//     {
//       image: "/image/commercial.jpg",
//       title: "Industrial and Investment Land",
//       description: "Warehouses, industrial plots, and raw land - perfect for factories, logistics, or future projects.",
//       link: "/property",
//       propertyType: "Buy",
//       payloadKey: "property_category_type",
//     },
//     {
//       image: "/image/pgpg.jpg",
//       title: "PG and Co-living",
//       description: "Affordable and community-style living for students and working professionals with shared amenities.",
//       link: "/property",
//       propertyType: "PG/Co-living",
//       payloadKey: "property_category_type",
//     }
//   ];

//   return (
//     <div className="bg-white py-8">
//       <div className="max-w-9xl mx-auto px-10">
//         <h2 className="text-2xl sm:text-4xl text-gray-900">
//           Explore our services
//         </h2>
//         <p className="text-gray-500 text-[18px]">Go from browsing to buying</p>

//         {/* Services Grid */}
//         <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-8 ">
//           {services.map((service, index) => (
//             <Link
//               key={index}
//               to={{
//                 pathname: service.link,
//                 state: { propertyType: service.propertyType },
//               }}
//               className="flex items-center bg-white rounded-2xl border border-gray-300 transform hover:scale-105 p-3 no-underline text-gray-800 hover:no-underline"
//             >
//               {/* Images Section - Left Side */}
//               <div className="w-1/3">
//                 <div className="w-full h-20 mb-2">
//                   <img
//                     src={service.image}
//                     alt={service.title}
//                     className="w-full h-full object-cover rounded-md"
//                   />
//                 </div>

//                 {/* Vertical Images */}
//                 <div className="flex space-x-2">
//                   <div className="w-1/2 h-12">
//                     <img
//                       src={service.image}
//                       alt={service.title}
//                       className="w-full h-full object-cover rounded-md"
//                     />
//                   </div>
//                   <div className="w-1/2 h-12">
//                     <img
//                       src={service.image}
//                       alt={service.title}
//                       className="w-full h-full object-cover rounded-md"
//                     />
//                   </div>
//                 </div>
//               </div>

//               {/* Text Section - Right Side */}
//               <div className="ml-4 w-1/2">
//                 <h3 className="text-lg font-semibold text-gray-800 mb-2">
//                   {service.title}
//                 </h3>
//                 <p className="text-base text-gray-600">{service.description}</p>
//               </div>
//             </Link>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ExploreServices;


import React from "react";
import { Link } from "react-router-dom";
import {
  FaHome,
  FaBuilding,
  FaMapMarkerAlt,
  FaUsers,
  FaCheckCircle,
  FaArrowRight,
  FaArrowLeft,
} from "react-icons/fa";

const services = [
  {
    badge: "Residential",
    badgeIcon: FaHome,
    icon: FaHome,
    image: "/image/plots.jpg",
    title: "Residential Properties",
    description:
      "Discover verified apartments, flats, villas, independent houses, and residential properties for sale and rent.",
    features: [
      "Apartments & Flats",
      "Villas & Bungalows",
      "Independent Houses",
      "Gated Communities",
    ],
    cta: "Explore Residential Properties",
    link: "/property",
    propertyType: "Residential",
    payloadKey: "building_type",
  },
  {
    badge: "Commercial",
    badgeIcon: FaBuilding,
    icon: FaBuilding,
    image: "/image/leasing.jpg",
    title: "Commercial Properties",
    description:
      "Find verified shops, offices, showrooms, warehouses, and commercial spaces for your business and investment needs.",
    features: [
      "Office Spaces",
      "Shops & Showrooms",
      "Warehouses",
      "Business Centers",
    ],
    cta: "Explore Commercial Properties",
    link: "/property",
    propertyType: "Commercial",
    payloadKey: "building_type",
  },
  {
    badge: "Plots & Land",
    badgeIcon: FaMapMarkerAlt,
    icon: FaMapMarkerAlt,
    image: "/image/commercial.jpg",
    title: "Plots & Land",
    description:
      "Explore residential, commercial, agricultural, and investment plots with location, size, and ownership details.",
    features: [
      "Residential Plots",
      "Agricultural Land",
      "Commercial Land",
      "Investment Opportunities",
    ],
    cta: "Explore Plots & Land",
    link: "/property",
    propertyType: "Buy",
    payloadKey: "property_category_type",
  },
  {
    badge: "PG & Co-Living",
    badgeIcon: FaUsers,
    icon: FaUsers,
    image: "/image/pgpg.jpg",
    title: "PG & Co-Living",
    description:
      "Find comfortable PGs, shared accommodations, and co-living spaces for students and working professionals.",
    features: [
      "Student PGs",
      "Working Professional PGs",
      "Co-Living Spaces",
      "Fully Furnished Options",
    ],
    cta: "Explore PG & Co-Living",
    link: "/property",
    propertyType: "PG/Co-living",
    payloadKey: "property_category_type",
  },
];

const ExploreServices = () => {
  return (
   
<section className="bg-white py-8">
  <div className="max-w-[1200px] mx-auto px-4 sm:px-8">
    {/* Header */}
    <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-6">
      <div>
        <span className="text-xs font-semibold tracking-widest text-[#c8962e] uppercase">
          Our Services
        </span>
        <h2 className="font-sans text-2xl sm:text-3xl font-bold text-[#2a1a1f] mt-1">
          Explore Our <span className="text-[#7a0c1e]">Real Estate Services</span>
        </h2>
        <p className="text-gray-500 text-sm mt-1">
          Find, buy, rent, sell, and invest in property with confidence.
        </p>
      </div>

      <div className="flex items-center gap-2">
        <Link
          to="/property"
          className="inline-flex items-center gap-2 bg-[#7a0c1e] text-white text-sm font-medium px-5 py-2.5 rounded-lg no-underline hover:no-underline hover:bg-[#620a18] transition"
        >
          View All <FaArrowRight className="text-xs" />
        </Link>
       
      </div>
    </div>

    {/* Cards: 2 per row */}
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      {services.map((service) => {
        const linkTo = {
          pathname: service.link,
          state: {
            propertyType: service.propertyType,
            payloadKey: service.payloadKey,
          },
        };

        return (
          <Link
            key={service.title}
            to={linkTo}
            aria-label={service.cta}
            className="group flex items-center gap-4 bg-white rounded-xl border border-gray-200 p-3 no-underline hover:no-underline transition duration-200 hover:-translate-y-0.5 hover:shadow-md hover:border-[#c8962e]"
          >
            <img
              src={service.image}
              alt={service.title}
              className="w-28 h-24 sm:w-36 sm:h-28 shrink-0 object-cover rounded-lg"
            />

            <div className="flex-1 min-w-0">
              <h3 className="text-base sm:text-lg font-semibold text-[#2a1a1f] truncate">
                {service.title}
              </h3>
              <p className="text-xs sm:text-[13px] text-gray-500 leading-snug mt-1 line-clamp-2">
                {service.description}
              </p>
              <span className="inline-flex items-center gap-1.5 text-xs font-semibold text-[#7a0c1e] mt-2 transition-all group-hover:gap-2.5">
                {service.cta} <FaArrowRight className="text-[10px]" />
              </span>
            </div>
          </Link>
        );
      })}
    </div>
  </div>
</section>


  );
};

export default ExploreServices;